import WinPublicSummary from '../../Summaries/summaryObjects/Implementation/WinPublicSummary';
import checkForTable from './checkForTable';

export default ((results) => {
    
    let existingTable = checkForTable(); 
  
      // Build the table content and Excel link
      for (var i = 0, il = results.features.length; i < il; i++) {
          var featureAttributes = results.features[i].attributes;
          if (!document.getElementById(featureAttributes.OBJECTID)) {
              // Create a new row
              var newRow = existingTable.insertRow();
          
              // Add cells to the row
              var cellData = [
                  featureAttributes.PIN,
                  featureAttributes.LOPHouseNumber + ' ' + featureAttributes.LOPPrefixDirectional + ' ' + featureAttributes.LOPStreetName + ' ' + featureAttributes.LOPStreetSuffix,
                  featureAttributes.OwnerLastName + ', ' + featureAttributes.OwnerFirstName,
                  featureAttributes.OwnerAddress1 + ' ' + featureAttributes.OwnerAddress2,
                  featureAttributes.OwnerCity + ', ' + featureAttributes.OwnerState + ' ' + featureAttributes.OwnerZip
              ];
  
              for (var cellText of cellData) {
                  var cell = newRow.insertCell();
                  cell.appendChild(document.createTextNode(cellText));
              }
          } 
      }
  
      // Check if the ResultsLink div already exists
      var resultsLinkDiv = document.getElementById('ResultsLink');
      if (resultsLinkDiv) {
          // Append the table to ResultsLink
          resultsLinkDiv.appendChild(existingTable);
          existingTable.classList.add('d-none'); 
      } else {
          console.error('ResultsLink div not found.');
      }
    })